<template>
    <el-dialog
        :title="(isForm ? (modelId ? '编辑' : '添加事件源') : '查看') + dialogTitle"
        :model-value="modelValue"
        width="900px"
        @close="closed"
        align-center
        :close-on-click-modal="false"
    >
        <el-form ref="formRef" :model="formData" v-loading="loading" :rules="isForm ? formRules : {}" label-width="125px">
            <el-row>
                <el-col :span="12">
                    <el-form-item label="子系统" prop="module">
                        <el-select v-model="formData.module" style="width: 100%" placeholder="请选择子系统" clearable>
                            <el-option
                                v-for="item in moduleOption"
                                :key="item.id"
                                :label="item.name"
                                :value="item.id"
                            ></el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="名称" prop="name">
                        <el-input
                            v-if="isForm"
                            style="width: 100%"
                            v-model="formData.name"
                            placeholder="请输入事件名称"
                        ></el-input>
                        <span v-else>{{ formData.name }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="编码" prop="code">
                        <el-input
                            v-if="isForm"
                            style="width: 100%"
                            v-model="formData.code"
                            placeholder="请输入事件编码"
                        ></el-input>
                        <span v-else>{{ formData.code }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="等级" prop="level">
                        <el-select v-if="isForm" v-model="formData.level" placeholder="请选择等级" style="width: 100%" clearable>
                            <el-option
                                v-for="item in levelOptions"
                                :key="item.level"
                                :label="item.label"
                                :value="Number(item.level)"
                            ></el-option>
                        </el-select>
                        <span v-else>{{ formData.level }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="显示排序" prop="list_order">
                        <el-input-number
                            v-if="isForm"
                            v-model="formData.list_order"
                            class="mx-4"
                            :min="0"
                            :max="999999"
                            controls-position="right"
                        />
                        <span v-else>{{ formData.list_order }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="用户设置" prop="is_set">
                        <el-radio-group v-if="isForm" style="width: 100%" v-model="formData.is_set" class="ml-4">
                            <el-radio :value="1" size="large">是</el-radio>
                            <el-radio :value="0" size="large">否</el-radio>
                        </el-radio-group>
                        <span v-else>{{ formData.is_set ? '是' : '否' }}</span>
                    </el-form-item>
                </el-col>
                <el-col :span="12">
                    <el-form-item label="阈值判断" prop="is_threshold">
                        <el-radio-group
                            v-if="isForm"
                            @change="formData.threshold_setting.data_type = ''"
                            style="width: 100%"
                            v-model="formData.is_threshold"
                            class="ml-4"
                        >
                            <el-radio :value="1" size="large">是</el-radio>
                            <el-radio :value="0" size="large">否</el-radio>
                        </el-radio-group>
                        <span v-else>{{ formData.is_threshold ? '是' : '否' }}</span>
                    </el-form-item>
                </el-col>
                <!-- 声音阈值相关配置 -->
                <el-row v-if="formData.is_threshold">
                    <el-col :span="12">
                        <el-form-item label="数据类型" prop="threshold_setting.data_type">
                            <el-select
                                v-if="isForm"
                                v-model="formData.threshold_setting.data_type"
                                @change="changeDataType"
                                style="width: 100%"
                                placeholder="数据类型"
                            >
                                <el-option
                                    v-for="item in dataOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                            <span v-else>{{ formData.threshold_setting.data_type }}</span>
                        </el-form-item>
                    </el-col>

                    <el-col :span="12">
                        <el-form-item label="数据项类型" prop="threshold_setting.input_type">
                            <el-select
                                v-if="isForm"
                                v-model="formData.threshold_setting.input_type"
                                style="width: 100%"
                                placeholder="数据项类型"
                            >
                                <el-option
                                    v-for="item in inputDataOpions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                            <span v-else>{{ formData.threshold_setting.input_type }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="验证规则" prop="threshold_setting.rules">
                            <el-select
                                v-if="isForm"
                                v-model="formData.threshold_setting.rules"
                                clearable
                                style="width: 100%"
                                placeholder="验证规则"
                                multiple
                                collapse-tags
                                collapse-tags-tooltip
                            >
                                <el-option
                                    v-for="item in ruleOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>
                            <span v-else>{{ formData.threshold_setting.rules }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col
                        :span="12"
                        v-if="
                            formData.threshold_setting?.data_type === 'int' ||
                            formData.threshold_setting?.data_type === 'float' ||
                            !formData.threshold_setting?.data_type
                        "
                    >
                        <el-form-item label="数据单位" prop="unit">
                            <el-input
                                v-if="isForm"
                                v-model="formData.threshold_setting.unit"
                                placeholder="请输数据单位"
                            ></el-input>
                            <span v-else>{{ formData.threshold_setting.unit }}</span>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="数据选项配置">
                            <el-input v-if="isForm" v-model="formData.threshold_setting.options" type="textarea"></el-input>
                            <span v-else>{{ formData.threshold_setting.options || '' }}</span>
                        </el-form-item>
                    </el-col>
                </el-row>
                <!-- 配置项设置列表 -->
                <div class="limitContainer" v-if="formData.threshold_setting?.data_type">
                    <div class="limitHeader">
                        <span style="font-weight: bold">限值配置</span>
                        <span>
                            <span style="margin-right: 20px">
                                <!-- <el-button type="info" plain style="height: 24px" @click="addMaxAndMin">最大值 - 最小值</el-button> -->
                            </span>
                            <el-button style="height: 24px; width: 72px" type="primary" plain :icon="Plus" @click="handleAddNeed">
                                添加
                            </el-button>
                        </span>
                    </div>
                    <div class="titleContainer">
                        <div class="leftIndex">序号</div>
                        <div class="limitType">值类型</div>
                        <div class="limitTitle">标题</div>
                        <div class="limitRequired">是否必填</div>
                        <div class="limitValue">限值</div>
                        <div class="limitPlaceholder">告警信息</div>
                        <div class="handleContainer">操作</div>
                    </div>
                    <div class="limitListContainer">
                        <el-scrollbar>
                            <el-form-item
                                class="limitItem"
                                v-for="(item, index) in formData.limit_setting"
                                :key="item.id"
                                :prop="`limit_setting[${index}]`"
                                :rules="formRules.limit_settingItem"
                                style="margin-left: 0"
                            >
                                <div class="leftIndex">{{ index + 1 }}、</div>
                                <div class="limitType">
                                    <el-select v-model="item.type" filterable placeholder="值类型" style="width: 90%">
                                        <el-option
                                            v-for="op in limitTypeOptions"
                                            :key="op.value"
                                            :label="op.label"
                                            :value="op.value"
                                        ></el-option>
                                    </el-select>
                                </div>
                                <div class="limitTitle">
                                    <el-input style="width: 90%" v-model="item.title" placeholder="请输入标题"></el-input>
                                </div>

                                <div class="limitRequired">
                                    <el-select v-model="item.required" filterable placeholder="是否必填" style="width: 90%">
                                        <el-option
                                            v-for="op in [
                                                { value: 1, label: '是' },
                                                { value: 0, label: '否' }
                                            ]"
                                            :key="op.value"
                                            :label="op.label"
                                            :value="op.value"
                                        ></el-option>
                                    </el-select>
                                </div>
                                <div class="limitValue">
                                    <el-input-number
                                        v-if="
                                            formData.threshold_setting.data_type === 'int' ||
                                            formData.threshold_setting.data_type === 'float'
                                        "
                                        v-model="item.value"
                                        class="mx-4"
                                        style="width: 90%"
                                        controls-position="right"
                                    />
                                    <el-select
                                        v-if="formData.threshold_setting.data_type === 'bool'"
                                        v-model="item.value"
                                        filterable
                                        placeholder="布尔类型"
                                        style="width: 90%"
                                    >
                                        <el-option
                                            v-for="op in [
                                                { value: true, label: '是' },
                                                { value: false, label: '否' }
                                            ]"
                                            :key="op.value"
                                            :label="op.label"
                                            :value="op.value"
                                        ></el-option>
                                    </el-select>
                                    <el-input
                                        v-if="formData.threshold_setting.data_type === 'char'"
                                        v-model="item.value"
                                        placeholder="字符串"
                                        style="width: 90%"
                                    ></el-input>
                                    <el-time-picker
                                        v-if="formData.threshold_setting.data_type === 'time'"
                                        v-model="item.value"
                                        format="HH:mm:ss"
                                        style="width: 90%"
                                        value-format="HH:mm:ss"
                                        placeholder="选择时间"
                                    />
                                    <el-date-picker
                                        v-if="formData.threshold_setting.data_type === 'date'"
                                        v-model="item.value"
                                        format="YYYY-MM-DD"
                                        style="width: 90%"
                                        value-format="YYYY-MM-DD"
                                        placeholder="选择日期"
                                    />
                                </div>
                                <div class="limitPlaceholder">
                                    <el-input style="width: 90%" v-model="item.alarm_msg" placeholder="请输入告警信息"></el-input>
                                </div>
                                <div class="handleContainer">
                                    <el-button
                                        type="danger"
                                        link
                                        :icon="Delete"
                                        @click="handleClickRemove(item, index)"
                                    ></el-button>
                                </div>
                            </el-form-item>
                        </el-scrollbar>
                    </div>
                </div>
                <el-col :span="24" v-if="formData.threshold_setting?.data_type">
                    <el-form-item label="是否为限值区间内" prop="is_set">
                        <el-radio-group style="width: 100%" v-model="formData.in_range" class="ml-4">
                            <el-radio :value="0" size="large">否</el-radio>
                            <el-radio :value="1" size="large">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-col>
            </el-row>
        </el-form>

        <template #footer>
            <span class="dialog-footer">
                <el-button @click="closed">取消</el-button>
                <el-button v-if="isForm" type="primary" :loading="submitLoading" @click="onConfirm">确定</el-button>
            </span>
        </template>
    </el-dialog>
</template>
<script setup>
import { defineEmits, defineProps, onMounted, ref } from 'vue'
import { getModuleOptionLists } from '@/api/module.js'
import {
    addEventSource,
    getEventSourceDetail,
    getEventSourceOptions,
    putEventSource
} from '@/api/eventConfig/eventManger/eventManger.js'
import { getAlarmLevelLists } from '@/api/eventConfig/alarmLevel/alarmLevel.js'
import { getDictDataSelect } from '@/utils/common.js'
import { getDictDataOptions } from '@/api/dictdata.js'
import { FormJsData, RulesJs } from './js/jsData'
import { ElMessage } from 'element-plus'
import { Delete, Plus } from '@element-plus/icons'
// import { validatePassword } from '@/utils/rules.js'
// import { LOCALFS_ROOT } from '@/constant'

const props = defineProps({
    modelValue: {
        type: Boolean,
        required: true
    },
    isForm: {
        type: Boolean,
        default: false
    },
    modelId: {
        type: String,
        required: false
    }
})
const emits = defineEmits(['update:modelValue', 'updateForm'])
// 子系统选项列表
const moduleOption = ref()
const filterModuleCode = ref(['app_auth', 'work'])
// 获取等级
const levelOptions = ref([])
// 数据类型
const dataOptions = ref([])
// 规则选项
const ruleOptions = ref([])
// 数据项类型
const inputDataOpions = ref([])

// 获取配置项值选项
const limitTypeOptions = ref([])

// 获取选项数据
const getOptionData = async () => {
    loading.value = true
    const res = await getModuleOptionLists()
    moduleOption.value = res.filter((item) => {
        if (!filterModuleCode.value.includes(item.id)) {
            return item
        }
    })
    const level = await getAlarmLevelLists()
    levelOptions.value = [{ label: '事件', level: 0 }, ...level]

    // 配置选项
    const dictData = await getDictDataOptions({ dict_code: 'configs_data_type' })
    const ruleData = await getDictDataOptions({ dict_code: 'configs_rule_type' })
    const typeData = await getDictDataOptions({ dict_code: 'configs_type' })
    dataOptions.value = getDictDataSelect(dictData)
    ruleOptions.value = getDictDataSelect(ruleData)
    inputDataOpions.value = getDictDataSelect(typeData)

    // 限制选项
    const { limit_type } = await getEventSourceOptions()
    limitTypeOptions.value = Object.entries(limit_type).map((item) => {
        return {
            label: item[1],
            value: item[0]
        }
    })
    loading.value = false
}

// 表单源
const formData = ref(FormJsData)
// 验证规则

const formRules = ref(RulesJs)
const dialogTitle = ref('')
const submitLoading = ref(false)
const formRef = ref(null)

// 关闭
const closed = () => {
    dialogTitle.value = ''
    document.querySelector('.el-dialog__body').scrollTo(0, 0)
    emits('update:modelValue', false)
    formRef.value && formRef.value.resetFields()
}

// 确定按钮点击事件
const onConfirm = async () => {
    if (!props.isForm) return
    if (props.modelId !== '') {
        await doPutSource()
    } else {
        await doAddSource()
    }
}
// 提交data数据修饰
const getPostFormData = () => {
    const postFormData = {}
    if (formData.value.id) {
        postFormData.id = formData.value.id
    }
    postFormData.module = formData.value.module
    postFormData.name = formData.value.name
    postFormData.code = formData.value.code
    postFormData.list_order = formData.value.list_order
    if (formData.value.level) {
        postFormData.is_set = formData.value.is_set
    }
    postFormData.level = String(formData.value.level)
    postFormData.is_threshold = formData.value.is_threshold
    if (postFormData.is_threshold) {
        postFormData.threshold_setting = {
            data_type: formData.value.threshold_setting.data_type,
            input_type: formData.value.threshold_setting.input_type,
            rules: formData.value.threshold_setting.rules,
            unit: formData.value.threshold_setting.unit,
            options: formData.value.threshold_setting.options ? JSON.parse(formData.value.threshold_setting.options) : {}
        }
        if (formData.value.threshold_setting?.data_type) {
            postFormData.limit_setting = formData.value.limit_setting
        }
        postFormData.in_range = formData.value.in_range
    }
    return postFormData
}

// 修改
const doPutSource = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const postFormData = getPostFormData()
        // await putEquipModel(formData.value)
        try {
            await putEventSource(postFormData)
            // 模块修改成功
            emits('updateForm')
            ElMessage.success('修改成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

// 添加
const doAddSource = async () => {
    // 进行表单校验
    formRef.value.validate(async (valid) => {
        if (!valid) return
        submitLoading.value = true
        const postFormData = getPostFormData()
        // await addEquipModel(formData.value)
        try {
            await addEventSource(postFormData)
            // 模块添加成功
            emits('updateForm')
            ElMessage.success('添加成功！')
            submitLoading.value = false
            closed()
        } catch {
            submitLoading.value = false
        }
    })
}

// 当数据类型发生变化时
const changeDataType = () => {
    if (formData.value.limit_setting.length) {
        formData.value.limit_setting.forEach((item) => {
            item.value = ''
        })
    }
}

// 添加限值
const handleAddNeed = () => {
    formData.value.limit_setting.push({
        title: '',
        alarm_msg: '',
        value: '',
        required: 1,
        type: 'equal'
    })
}

// // 增加最大值最小值
// const addMaxAndMin = () => {
//     formData.value.limit_setting.push(
//         {
//             title: '最大值',
//             placeholder: '',
//             value: '',
//             required: 1,
//             type: 'max'
//         },
//         {
//             title: '最小值',
//             placeholder: '',
//             value: '',
//             required: 1,
//             type: 'min'
//         }
//     )
// }

// 删除限值
const handleClickRemove = (data, index) => {
    formData.value.limit_setting.splice(index, 1)
}
const loading = ref(false)
// 获取点位详情
const getEventDetail = async () => {
    loading.value = true
    const { name, code, id, is_set, level, module, is_threshold, threshold_setting, limit_setting, in_range, list_order } =
        await getEventSourceDetail(props.modelId)
    formData.value.id = id
    formData.value.name = name
    formData.value.code = code
    formData.value.is_set = is_set
    formData.value.level = level
    formData.value.module = module
    formData.value.is_threshold = is_threshold
    formData.value.list_order = list_order
    if (is_threshold) {
        formData.value.threshold_setting = threshold_setting
        if (threshold_setting.options) {
            formData.value.threshold_setting.options = JSON.stringify(threshold_setting.options)
        }
    }
    if (limit_setting) {
        formData.value.limit_setting = limit_setting
        console.log(limit_setting)
    } else {
        formData.value.limit_setting = []
    }
    formData.value.in_range = in_range
    loading.value = false
}

onMounted(async () => {
    await getOptionData()
    if (props.modelId) {
        await getEventDetail()
    } else {
        formData.value = FormJsData
    }
})
</script>

<style lang="scss" scoped>
.albums-lists {
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;

    .img-item {
        width: 100px;
        height: 100px;
        background-color: #999;
        border-radius: 5px;
        margin-right: 10px;
    }
}

.albums-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100px;
        height: 100px;

        .avatar-uploader-icon {
            margin-top: 36px;
        }
    }

    :deep(.el-upload-list__item-preview),
    :deep(.el-icon--zoom-in) {
        display: none;
    }
}

.files-upload-lists {
    :deep(.el-upload-list__item),
    :deep(.el-upload--picture-card) {
        width: 100%;
        height: auto;
    }
}
body {
    margin: 0;
}
.example-showcase .el-loading-mask {
    z-index: 9;
}

.limitContainer {
    width: 100%;
    .limitHeader {
        display: flex;
        align-items: center;
        justify-content: space-between;
        span {
            line-height: 24px;
        }
    }
    .titleContainer {
        width: 100%;
        height: 35px;
        display: flex;
        margin-top: 10px;
        line-height: 35px;
        background-color: #f5f7fa;
        border-left: 1px solid #d9d9e1;
        border-right: 1px solid #d9d9e1;
        border-top: 1px solid #d9d9e1;
        .leftIndex {
            width: 45px;
            display: flex;
            justify-content: center;
        }
        .limitType {
            width: 110px;
            text-align: center;
            box-sizing: border-box;
            border-left: 1px solid #d9d9e1;
        }
        .limitTitle {
            width: 180px;
            text-align: center;
            box-sizing: border-box;
            border-left: 1px solid #d9d9e1;
        }
        .limitPlaceholder {
            width: 180px;
            text-align: center;
            box-sizing: border-box;
            border-left: 1px solid #d9d9e1;
        }
        .limitRequired {
            width: 90px;
            text-align: center;
            box-sizing: border-box;
            border-left: 1px solid #d9d9e1;
        }
        .limitValue {
            flex: 1;
            text-align: center;
            box-sizing: border-box;
            border-left: 1px solid #d9d9e1;
        }
        .handleContainer {
            width: 50px;
            text-align: center;
            border-left: 1px solid #d9d9e1;
        }
    }
    .limitListContainer {
        :deep(.el-form-item__content) {
            margin-left: 0 !important;
        }
        :deep(.el-input-number__increase) {
            height: 15px !important;
        }
        :deep(.el-input-number__decrease) {
            height: 15px !important;
        }
        width: 100%;
        height: 200px;
        border: 1px solid #d9d9e1;
        padding: 5px 0;
        .limitItem {
            border-bottom: 1px solid #d5d5d5;
            padding: 4px 0;
            display: flex;
            height: 55px;
            margin-bottom: 0;
            align-items: flex-start;
            &:last-child {
                border: none;
            }
            .leftIndex {
                width: 45px;
                display: flex;
                justify-content: center;
            }
            .limitType {
                width: 110px;
                text-align: center;
                box-sizing: border-box;
                // border-left: 1px solid #d9d9e1;
            }
            .limitTitle {
                width: 180px;
                text-align: center;
                box-sizing: border-box;
                // border-left: 1px solid #d9d9e1;
            }
            .limitPlaceholder {
                width: 180px;
                text-align: center;
                box-sizing: border-box;
                // border-left: 1px solid #d9d9e1;
            }
            .limitRequired {
                width: 90px;
                text-align: center;
                box-sizing: border-box;
                // border-left: 1px solid #d9d9e1;
            }
            .limitValue {
                flex: 1;
                text-align: center;
                box-sizing: border-box;
                // border-left: 1px solid #d9d9e1;
            }
            .handleContainer {
                width: 50px;
                text-align: center;
                // border-left: 1px solid #d9d9e1;
            }
        }
    }
}
</style>
